import {
    apiRequest,
    legalList,
    legalActive,
    legalInactive
} from "../../../../../services/adapters/master/legalService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", legalList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", legalInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", legalActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository